export const header = {
  headers: {
    "x-api-key": process.env.REACT_APP_X_API_KEY,
  },
};
